export enum Permission {
  ShoppingListModify = 'shoppers_retailer_settings.modify',
  ShoppingListView = 'shoppers_retailer_settings.view',
}
